import {Directive, HostBinding, HostListener} from '@angular/core';
import {NavigationService} from "@shared/services/navigation-service.service";

@Directive({
  selector: '[backButton]'
})
export class BackButtonDirective {
  constructor(private navigation: NavigationService) {}
  @HostBinding('style.cursor') cursor: string = 'pointer' ;
  @HostListener('click')
  onClick(): void {
    this.navigation.back();
  }
}
